import "src/common/bugsnag";

import "src/lighthouse/load_stimulus_controllers";
import "@rails/actiontext";

import "details-element-polyfill";
import "src/common/element_polyfill";
import "src/common/element_overrides";

import "trix";
import "src/common/trix_overrides";

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

import {Turbo} from "@hotwired/turbo-rails";
import {StreamActions} from "@hotwired/turbo";

Turbo.session.drive = true;
import TurboPower from "turbo_power";
TurboPower.initialize(StreamActions);

import * as Confirm from "src/admin/components/confirm";
Turbo.config.forms.confirm = Confirm.handleConfirm;

window.dispatchMapsEvent = function(...args) {
  const event = new Event("google-maps-callback", {bubbles: true, cancelable: true});
  event.args = args;
  window.dispatchEvent(event);
};
